module.exports = __webpack_public_path__ + "img/AB9_0505.eae545e9.jpg";